<template>
  <div class="card">
    <div class="card-header">
      <h3>{{ locale.edit_company_profile }}</h3>
    </div>
    <div class="card-body">
      <label>{{ locale.name }}*</label>
      <fg-input
          prepend-icon="fas fa-user"
          v-bind:placeholder="locale.name"
          v-model="user.name"
          addon-left-icon="now-ui-icons users_circle-08"
      />

      <label>{{ locale.registered_no }}*</label>
      <br>
      <the-mask class="mb-2 w-100" mask="######-####" placeholder="XXXXXX-XXXX" @keyup.native="validatePidn()" v-model="user.registered_no"/>
      <br>

      <label>{{ locale.email }}</label>
      <fg-input
          prepend-icon="fas fa-envelope"
          v-bind:placeholder="locale.email"
          v-model="user.email"
          addon-left-icon="now-ui-icons ui-1_email-85"
      />

      <label>{{ locale.phone }}</label>
      <fg-input
          prepend-icon="fas fa-phone"
          v-bind:placeholder="locale.phone"
          v-model="user.phone"
          addon-left-icon="now-ui-icons tech_mobile"
          :error="apiValidationErrors.phone"
      />
      <br>
      <hr>
      <div class="text-center"><h5 class="my-0"><b>Address</b></h5></div>
      <div class="d-flex mx-3 flex-column">
        <div class="d-flex justify-content-around">
          <div class="d-flex flex-column w-75">
            <span class="w-100">{{ locale.address_line1 }}:* </span>
            <input class="w-100" style="height: 2rem" v-model="user.address_line1">
          </div>
          <div class="ml-3 d-flex flex-column w-75">
            <span class="w-100">{{ locale.address_line2 }}: </span>
            <input class="w-100" style="height: 2rem" v-model="user.address_line2">
          </div>
          <div class="mb-3 d-flex flex-column">
            <n-button v-bind:class="map_visible ? 'hide-map' : 'show-map'"
                      style="height: 3rem; width: 1rem; background-color: white;"
                      @click.native="addressForm()"></n-button>
          </div>
        </div>
        <div class="mb-3 d-flex flex-column">
          <span class="w-100">{{ locale.postal_code }}:* </span>
          <input class="w-100" style="height: 2rem" v-model="user.postal_code">
        </div>
        <div class="mb-3 d-flex flex-column">
          <span class="w-100">{{ locale.city_name }}:* </span>
          <input class="w-100" style="height: 2rem" v-model="user.city">
        </div>
        <div class="mb-3 d-flex flex-column">
          <span class="w-100">{{ locale.country_name }}:* </span>
          <input class="w-100" style="height: 2rem" v-model="user.country">
        </div>
      </div>
      <hr>
      <template>
        <modal name="address-form"
               :adaptive="true" :resizable="true" :minHeight="500"
               @opened="modalOpened"
        >
          <template>
            <div style="margin: 1em; margin-top: 2em;">
              <div class="d-flex justify-content-between">
                <div class="mb-3 d-flex flex-column w-100">
                  <span>{{ locale.address }}</span>
                  <div id="geocoder"></div>
                </div>
              </div>

              <br>
              <div v-show="map_visible" id="map" style="max-height: 250px"></div>
            </div>
            <div class="text-center" type="primary" @click="onModalHide('address-form')">
              <n-button>Ok</n-button>
            </div>
          </template>
          <br>
        </modal>
      </template>
      <i v-if="!pidn_valid">* {{ locale.personal_no }} {{locale.is_not_valid}}</i>
      <div class="my-4">
        <n-button
            type="button"
            class="btn btn-sm btn-primary"
            :class="{disabled: !(checkRequires() && pidn_valid)}"
            @click.native="handleProfileUpdate()"
        >
          {{ locale.submit }}
        </n-button>
      </div>
    </div>
  </div>

</template>
<script>
import formMixin from "@/mixins/form-mixin";
import {Select, Option} from "element-ui";

import mapboxgl from "mapbox-gl";
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import "@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css";
import 'mapbox-gl/dist/mapbox-gl.css';

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  name: "UserEditCard",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
  },

  mixins: [formMixin],

  data() {
    return {
      access_token: process.env.VUE_APP_MAP_BOX_API_KEY,
      center: [18, 65],
      map: {},

      selected_mapbox_address: '',
      selected_latitude: '',
      selected_longitude: '',

      locale: '',
      user: {},
      countries: [],
      cities: [],
      postal_codes: [],
      country_cities: [],
      city_pcs: [],

      selected_country: '',
      selected_al1: '',
      selected_al2: '',
      selected_city: '',
      selected_pc: '',
      map_visible: true,
      pidn_valid: false,
    };
  },

  methods: {
    validatePidn() {
      let regex = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-|+]{0,1})?(\d{3})(\d{0,1})$/;
      this.pidn_valid = this.user.registered_no.match(regex);
    },

    checkRequires() {
      return (this.user.name != '' && this.user.name != null && this.user.registered_no != '' && this.user.registered_no != null && this.user.address_line1 != '' && this.user.address_line1 != null
          && this.user.postal_code != '' && this.user.postal_code != null && this.user.city != '' && this.user.city != null && this.user.country != '' && this.user.country != null)
    },

    modalOpened(event) {
      this.createMap();
    },

    onModalHide(name) {
      this.$modal.hide(name);
    },

    addressForm() {
      this.$modal.show('address-form');
    },

    showHideMap() {
      this.map_visible = !this.map_visible;
    },

    async createMap() {
      try {
        mapboxgl.accessToken = this.access_token;
        this.map = new mapboxgl.Map({
          container: 'map',
          style: "mapbox://styles/mapbox/streets-v11?optimize=true",
          center: this.center,
          zoom: 4,
        });

        let geocoder = new MapboxGeocoder({
          accessToken: this.access_token,
          mapboxgl: mapboxgl,
          marker: false,
        });

        document.getElementById('geocoder').appendChild(geocoder.onAdd(this.map));
        geocoder.setPlaceholder(this.locale.client_address + '*');
        this.map.addControl(new mapboxgl.NavigationControl());
        this.selected_mapbox_address = this.user.address_line1 + ', ' + this.user.postal_code + ', ' + this.user.city + ', ' + this.user.country;

        geocoder.on("result", (e) => {
          this.user.country = e.result.context.find(elem => elem.id.includes('country')).text;
          this.user.city = e.result.context.find(elem => elem.id.includes('place')).text;
          this.user.postal_code = e.result.context.find(elem => elem.id.includes('postcode')).text;
          if (e.result.text)
            this.user.address_line1 = e.result.text;
          if (e.result.address)
            this.user.address_line1 += ' ' + e.result.address;
          this.selected_mapbox_address = e.result.place_name;
          this.selected_latitude = e.result.geometry.coordinates[0];
          this.selected_longitude = e.result.geometry.coordinates[1];
          console.log(this.selected_mapbox_address);
          const marker = new mapboxgl.Marker({
            draggable: true,
            color: "#D80739",
          })
              .setLngLat(e.result.center)
              .addTo(this.map);
          this.center = e.result.center;
          marker.on("dragend", (e) => {
            this.center = Object.values(e.target.getLngLat());
            var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
                + this.center[0] + ', ' + this.center[1]
                + '.json?access_token=' + this.access_token;
            fetch(url)
                .then(async response => {
                  const data = await response.json();
                  marker.remove();
                  geocoder.query(data.features[0].place_name);
                });
          });
        });
        if (this.selected_mapbox_address)
          geocoder.query(this.selected_mapbox_address);
      } catch (err) {
        console.log("map error", err);
      }
    },

    async getCountries() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/list-countries', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.countries = data;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async getCities() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/list-cities', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.cities = data;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async getPostalCodes() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/list-postal-codes', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.postal_codes = data;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    getCountryCities() {
      this.country_cities = this.cities.filter(elem => elem.country_id == this.selected_country);
      this.selected_city = '';
      this.selected_pc = '';
      this.city_pcs = [];
    },

    getCityPCodes() {
      this.city_pcs = this.postal_codes.filter(elem => elem.city_id == this.selected_city);
      this.selected_pc = '';
    },

    async handleProfileUpdate() {
      this.user.postal_code = this.user.postal_code.replace(/\s/g, '');
      this.selected_mapbox_address = this.user.address_line1 + ', ' + this.user.postal_code + ', ' + this.user.city + ', ' + this.user.country;
      let mb = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
          + this.selected_mapbox_address
          + '.json?access_token=' + this.access_token;

      await fetch(mb)
          .then(async response => {
            const data = await response.json();
            if (!data.features.length)
            {
              this.selected_latitude = '';
              this.selected_longitude = '';
              return;
            }

            this.user.country = data.features[0].context.find(elem => elem.id.includes('country')).text;
            this.user.city = data.features[0].context.find(elem => elem.id.includes('place')).text;
            this.user.postal_code = data.features[0].context.find(elem => elem.id.includes('postcode')).text;
            if (data.features[0].text)
              this.user.address_line1 = data.features[0].text;
            if (data.features[0].address)
              this.user.address_line1 += ' ' + data.features[0].address;
            this.selected_mapbox_address = data.features[0].place_name;
            this.selected_latitude = data.features[0].geometry.coordinates[0];
            this.selected_longitude = data.features[0].geometry.coordinates[1];
          });

      // if (!this.selected_latitude && !this.selected_longitude)
      // {
      //   alert(this.locale.address + ' ' + this.locale.is_not_valid);
      //   return;
      // }

      let provider_data = {
        'name': this.user.name,
        'registered_no': this.user.registered_no,
        'email': this.user.email,
        'phone': this.user.phone,
        'address_line1': this.user.address_line1,
        'address_line2': this.user.address_line2,
        'country': this.user.country,
        'city': this.user.city,
        'postal_code': this.user.postal_code,
        'full_address': this.selected_mapbox_address,
        'latitude': this.selected_latitude,
        'longitude': this.selected_longitude,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(provider_data)
      };

      await fetch(url + "/update-company-profile", requestOptions)
          .then(response => this.getProfile());
    },

    async getProfile() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/company-profile', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.user = data[0];
            this.validatePidn();
            this.selected_mapbox_address = this.user.full_address;
            this.selected_latitude = this.user.latitude;
            this.selected_longitude = this.user.longitude;
            await this.createMap();
            // this.loadAddress();
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    loadAddress() {
      this.selected_country = this.user.country_id;
      this.getCountryCities();
      this.selected_city = this.user.city_id;
      this.getCityPCodes();
      this.selected_pc = this.user.postal_code_id;
    },

    async getData() {
      // await this.getCountries();
      // await this.getCities();
      // await this.getPostalCodes();
      await this.getProfile();
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    this.locale = this.$getLocale();
  },

};
</script>
<style scoped>
.show-map {
  background-image: url("../../../../public/img/icons/map-show.svg");
}

.hide-map {
  background-image: url("../../../../public/img/icons/map-hide.svg");
}

input {
  border-radius: 30px;
  border: 1px solid #E3E3E3;
  height: 2rem;
}

input:focus {
  border: 1px solid #f96332;
}
</style>

<style>
.mapboxgl-ctrl-geocoder {
  width: 500px;
  max-width: 500px !important;
}
</style>